import { render } from "./CalendarXs.vue?vue&type=template&id=5068b9b7"
import script from "./CalendarXs.vue?vue&type=script&lang=js"
export * from "./CalendarXs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__